import { default as ViewMultiplePoliciesPage } from './ViewMultiplePoliciesPageWrapper';

export default ViewMultiplePoliciesPage;
